import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login'
import Dashboard from '@/components/Home/Dashboard'
import Customers from '@/components/Modules/Customers'
import Emails from '@/components/Modules/Emails'
import DeepEmails from '@/components/Modules/DeepEmails'
import Products from '@/components/Modules/Products'
import MessageBoard from '@/components/Modules/MessageBoard'
import Users from '@/components/Modules/Users'
import ChatGPT from '@/components/Modules/ChatGPT'
import Tools from '@/components/Modules/Tools'
import ALCMailer from '@/components/Modules/ALCMailer'
import SharedFiles from '@/components/Modules/SharedFiles'
import Schedule from '@/components/Modules/Schedule'
import Distribute from '@/components/Modules/Distribute'
import WebsitesIndex from '@/components/Modules/Websites/Index'
import WebsitesList from '@/components/Modules/Websites/List'
import WebsitesDetail from '@/components/Modules/Websites/Detail'
import WebsitesDomains from '@/components/Modules/Websites/Domains'
import WebsitesDomainsDetail from '@/components/Modules/Websites/DomainsDetail'
import WebsitesDnspod from '@/components/Modules/Websites/Dnspod'
import WebsitesDnspodDetail from '@/components/Modules/Websites/DnspodDetail'

Vue.use(Router)

const DEFAULT_TITLE = 'CRM - Powered By Alchemist'

const routeTitleMap = {
  dashboard: '统计报表',
  customers: '客户管理',
  alc_mailer: '邮件中心',
  emails: '邮件群发',
  deep_emails: '邮箱挖掘',
  distribute: '邮件分发',
  products: '产品资料',
  schedule: '待办事项',
  users: '用户管理',
  tools: '通用工具',
  shared_files: '共享文件',
  websites: '建站系统'
}

function getRouteTitle(path) {
  if (path === '/login') {
    return DEFAULT_TITLE
  }

  const currentPath = path.replace(/^\//, '').split('/')[0]

  try {
    const menu = JSON.parse(localStorage.getItem('menu') || '[]')
    const currentMenu = menu.find(item => item.path === currentPath)

    if (currentMenu && currentMenu.title) {
      return currentMenu.title
    }
  } catch (e) {}

  return routeTitleMap[currentPath] || DEFAULT_TITLE
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers
    },
    {
      path: '/emails',
      name: 'emails',
      component: Emails
    },
    {
      path: '/deep_emails',
      name: 'deep_emails',
      component: DeepEmails
    },
    {
      path: '/products',
      name: 'products',
      component: Products
    },
    {
      path: '/message_board',
      name: 'message_board',
      component: MessageBoard
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/schedule',
      name: 'schedule',
      component: Schedule
    },
    {
      path: '/chatgpt',
      name: 'chatgpt',
      component: ChatGPT
    },
    {
      path: '/tools',
      name: 'tools',
      component: Tools
    },
    {
      path: '/alc_mailer',
      name: 'alc_mailer',
      component: ALCMailer
    },
    {
      path: '/shared_files',
      name: 'shared_files',
      component: SharedFiles
    },
    {
      path: '/distribute',
      name: 'distribute',
      component: Distribute
    },
    {
      path: '/websites',
      name: 'websites',
      component: WebsitesIndex
    },
    {
      path: '/websites/list',
      name: 'websites_list',
      component: WebsitesList
    },
    {
      path: '/websites/detail/:domain',
      name: 'websites_detail',
      component: WebsitesDetail
    },
    {
      path: '/websites/domains',
      name: 'websites_domains',
      component: WebsitesDomains
    },
    {
      path: '/websites/domains/:domain',
      name: 'websites_domains_detail',
      component: WebsitesDomainsDetail
    },
    {
      path: '/websites/dnspod',
      name: 'websites_dnspod',
      component: WebsitesDnspod
    },
    {
      path: '/websites/dnspod/:domain',
      name: 'websites_dnspod_detail',
      component: WebsitesDnspodDetail
    }
  ]
})

router.afterEach((to) => {
  document.title = getRouteTitle(to.path)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js